<template>
    <v-container>
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
            <v-container style="text-align: center">
                <v-progress-circular :size="50" color="#234a98" indeterminate></v-progress-circular>
                <p class="pt-2" style="font-size: 14px; color: #234a98">
                    {{ $t('common.loading') }}
                </p>
            </v-container>
        </v-overlay>
        <v-dialog persistent max-width="600" v-model="dialogAlert">
            <v-card>
                <v-card-title>
                    Please, fill the fields below
                </v-card-title>
                <v-card-text id="makeMeBlue">
                    <v-form ref="alertForm" v-model="isAlertFormValid">
                        <v-text-field 
                            v-model="alertName" 
                            label="Title" 
                            outlined 
                            color="#213A8F" 
                            maxlength="50" 
                            counter 
                            :rules="[rules.required]"
                        />
                        <v-select 
                            v-model="client" 
                            color="#213A8F" 
                            outlined 
                            :items="clients" 
                            label="Client"
                            prepend-inner-icon="mdi-account" 
                            append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" 
                            required 
                            v-if="showClient"
                            :rules="[rules.required]"
                        />
                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="building" 
                                    color="#213A8F" 
                                    outlined 
                                    :items="buildings" 
                                    label="Building"
                                    prepend-inner-icon="mdi-home" 
                                    append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" 
                                    v-if="showBuilding"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="floor" 
                                    color="#213A8F" 
                                    outlined 
                                    :items="floors" 
                                    label="Floor"
                                    prepend-inner-icon="mdi-floor-plan" 
                                    append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" 
                                    :key="f" 
                                    v-if="showFloor"
                                />
                            </v-flex>
                        </v-layout>

                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="area" 
                                    color="#213A8F" 
                                    outlined 
                                    :items="areas" 
                                    label="Area"
                                    prepend-inner-icon="mdi-texture-box" 
                                    append-icon="mdi-arrow-down-drop-circle-outline"
                                    append-icon-color="#213A8F" 
                                    :key="a" 
                                    v-if="showArea"
                                />
                            </v-flex>
                        </v-layout>
                        <!-- <v-select v-model="sensore" color="#213A8F" outlined :items="sensors" label="Select one sensor"
                            prepend-inner-icon="mdi-access-point-network" append-icon="mdi-arrow-down-drop-circle-outline"
                            append-icon-color="#213A8F" /> -->
                        <v-layout>
                            <v-flex xs-11 md-11 sm-11>
                                <v-select 
                                    v-model="sensor" 
                                    multiple 
                                    prepend-inner-icon="mdi-access-point-network"
                                    append-icon="mdi-arrow-down-drop-circle-outline" 
                                    :items="filteredSensors" 
                                    label="Sensor"
                                    outlined 
                                    v-if="showSensor"
                                    :rules="[rules.required]"
                                />
                            </v-flex>
                        </v-layout>
                        <v-text-field 
                            v-model="email" 
                            color="#213A8F" 
                            outlined 
                            label="email (use ; to separate emails)"
                            prepend-inner-icon="mdi-email"
                            :rules="[rules.required, rules.email]"
                        />
                        <v-text-field 
                            v-model="emailCustomMessage" 
                            color="#213A8F" 
                            outlined
                            label="Insert your custom message here:" 
                            prepend-inner-icon="mdi-email"
                        />
                        <!-- <v-text-field v-model="sms" color="#213A8F" outlined label="Sms number (use ; to separate phone numbers)" prepend-inner-icon="mdi-message"/> -->
                        <v-text-field 
                            v-model="alertValue" 
                            color="#213A8F" 
                            outlined 
                            label="Alert Value (%) - n. of events"
                            prepend-inner-icon="mdi-alert"
                            :rules="[rules.required, rules.number]"
                        />

                        <!-- <v-switch class="justify-right" v-model="active" :label="active ? 'Active' : 'Disabled'"></v-switch> -->
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogAlert = false">Cancel</v-btn>
                    <v-btn text color="#213A8F" @click="SaveData" :disabled="!isAlertFormValid">Save rule</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Dialog di conferma eliminazione -->
        <v-dialog persistent max-width="500" v-model="dialogDeleteConfirm">
            <v-card>
                <v-card-title class="headline">
                    {{ $t('alertsManagement.deleteConfirm.title') }}
                </v-card-title>
                <v-card-text>
                    <p>{{ $t('alertsManagement.deleteConfirm.message', { title: itemToDelete?.Title }) }}</p>
                    <p class="text-caption text--secondary">{{ $t('alertsManagement.deleteConfirm.description') }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="dialogDeleteConfirm = false">
                        {{ $t('common.cancel') }}
                    </v-btn>
                    <v-btn text color="red" @click="confirmDelete">
                        {{ $t('common.delete') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Overlay di caricamento per eliminazione -->
        <v-overlay :value="isDeleting" z-index="9999">
            <v-progress-circular
                indeterminate
                size="64"
                color="#213A8F"
            ></v-progress-circular>
            <div class="mt-4 text-center">
                <p class="white--text">{{ $t('common.loading') }}</p>
            </div>
        </v-overlay>
        
        <!-- Sezione filtri -->
        <v-card class="mt-4 mb-4">
            <v-layout id="makeMeBlue">
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="filterClient" color="#213A8F" outlined :items="filterClients" :label="$t('manageSensors.client')"
                        prepend-inner-icon="mdi-account" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select prepend-inner-icon="mdi-home" v-model="filterBuilding" :items="filterBuildings" :label="$t('manageSensors.building')"
                        outlined append-icon="mdi-arrow-down-drop-circle-outline" :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select prepend-inner-icon="mdi-floor-plan" class="ml-2"
                        append-icon="mdi-arrow-down-drop-circle-outline" v-model="filterFloor" :items="filterFloors"
                        :label="$t('manageSensors.floor')" outlined :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="filterArea" color="#213A8F" outlined :items="filterAreas" :label="$t('manageSensors.area')"
                        prepend-inner-icon="mdi-texture-box" append-icon="mdi-arrow-down-drop-circle-outline"
                        append-icon-color="#213A8F" :no-data-text="$t('common.noDataAvailable')" />
                </v-flex>
                <v-flex xs6 sm6 md3 class="mt-4 mb-4 ml-4 mr-4">
                    <v-select v-model="filterSensor" prepend-inner-icon="mdi-access-point-network"
                        append-icon="mdi-arrow-down-drop-circle-outline" :items="filterSensors" :label="$t('manageSensors.sensor')" outlined
                        :no-data-text="$t('common.noDataAvailable')">
                    </v-select>
                </v-flex>
            </v-layout>
            <v-card-actions>
                <v-btn text @click="ClearFilter">
                    <span style="color: #213A8F;">{{ $t('manageSensors.clearFilter') }}</span>
                    <v-icon color="#213A8F" left>mdi-close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn @click="ApplyFilter">
                    <span style="color: #213A8F;">{{ $t('manageSensors.filter') }}</span>
                    <v-icon color="#213A8F" left>mdi-magnify</v-icon>
                </v-btn>
            </v-card-actions>
        </v-card>
        
        <v-card>
            <v-card-text class="mt-4"><v-icon color="#213A8F" text
                    @click="CreateNew()">mdi-plus-circle-outline</v-icon>{{ $t('alertsManagement.createRule') }}</v-card-text>
            <v-card-text>
                <v-data-table v-bind:headers="headers" :items="list" :hide-default-footer="true" disable-pagination
                    class="elevation-1 mt-4" no-data-text="No devices connected yet">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td></td>
                            <td>{{ item.Title }}</td>
                            <td>{{ item.DisplayName }}</td>
                            <!-- <td>{{ item.PhoneNumbers }}</td> -->
                            <td>{{ item.EmailAddress }}</td>
                            <td v-if="item.Active == 0"><v-icon color="red">mdi-circle</v-icon></td>
                            <td v-if="item.Active == 1"><v-icon color="green">mdi-circle</v-icon></td>
                            <td><v-icon @click="OpenDialog(item)">mdi-pencil</v-icon><v-icon
                                    @click="DeleteAlert(item)">mdi-delete</v-icon></td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import axios from "axios";
export default {
    data() {
        return {
            dispenserMessage: "Paper level low. Please refill promptly.",
            doorMessage: "High activity detected. Please schedule cleaning.",
            airMessage: "Air quality alert. Please verify ventilation.",
            smartButtonMessage: "Multiple negative feedbacks received. Please inspect cleanliness urgently.",
            smartBinMessage: "Waste bin full. Please empty immediately.",
            filteredSensors: [],
            showClient: true,
            emailCustomMessage: '',
            showSensor: true,
            showBuilding: false,
            showFloor: false,
            showArea: false,
            clients: [],
            client: '',
            buildings: [],
            building: '',
            floors: [],
            floor: '',
            areas: [],
            area: '',
            sensors: [],
            sensor: '',
            list: [],
            alertValue: 0,
            dialogAlert: false,
            dialogDeleteConfirm: false,
            itemToDelete: null,
            isDeleting: false,
            active: true,
            alertName: "",
            email: "",
            sms: "",
            id: null,
            id_sensore: '',
            sensore: '',
            display_name: '',
            isAlertFormValid: false,
            overlay: false,
            // Variabili per i filtri
            filterClients: [],
            filterClient: '',
            filterBuildings: [],
            filterBuilding: '',
            filterFloors: [],
            filterFloor: '',
            filterAreas: [],
            filterArea: '',
            filterSensors: [],
            filterSensor: '',
            rules: {
                required: v => !!v || 'This field is required',
                email: v => {
                    if (!v) return true;
                    const emails = v.split(';').map(email => email.trim());
                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return emails.every(email => emailRegex.test(email)) || 'Please enter valid email addresses';
                },
                number: v => {
                    if (!v) return true;
                    return !isNaN(v) && v > 0 || 'Please enter a valid positive number';
                }
            },
        }
    },
    computed: {
        headers() {
            return [{ text: "", align: "", value: "" },
            { text: this.$t('alertsManagement.title'), align: "center", value: "Title" },
            { text: this.$t('alertsManagement.sensor'), align: "center", value: "DisplayName" },
            // { text: "PHONE NUMBERS", align: "center", value: "PhoneNumbers" },
            { text: this.$t('alertsManagement.emailAddresses'), align: "center", value: "EmailAddresses" },
            { text: this.$t('alertsManagement.active'), align: "center", value: "Active" },
            { text: this.$t('manageSensors.actions'), align: "center", value: "" },
            { text: "", align: "center", value: "" },]
        }
    },
    created() {
        if (this.$store.state.company == null || this.$store.state.company == undefined || this.$store.state.company == '') {
            let token = localStorage.getItem("token");
            if (token != null && token != undefined && token != '') {
                axios.defaults.headers.common["Authorization"] = token;
                axios.post(this.$store.state.URL_REFRESH_TOKEN,
                    {

                    })
                    .then(res => {
                        if (res.data.result == "ok") {
                            this.$store.state.company = res.data.company;
                            localStorage.setItem('token', res.data.token);
                            localStorage.setItem('company', res.data.company)
                            this.$store.state.menu = res.data.menu;
                            console.log(this.$store.state.menu)
                            this.$store.state.avatar = res.data.avatar;
                            this.$store.state.displayName = res.data.displayName;
                            axios.defaults.headers.common["Authorization"] = res.data.token;
                            axios.post(this.$store.state.URL_COMPANY_DATA, {
                                "Company": this.$store.state.company
                            })
                                .then(() => {
                                    this.overlay = true;
                                    axios.post(this.$store.state.URLGETALERTSENSORS, {
                                        "company": this.$store.state.company
                                    }).
                                        then(res => {
                                            this.sensors.length = 0;
                                            if (res.data) {
                                                res.data.forEach(el => {
                                                    var e = {
                                                        DisplayName: el.DisplayName,
                                                        DispenserUnique: el.DispenserUnique,

                                                    }
                                                    this.sensors.push({ text: el.DisplayName, value: e });
                                                })
                                                this.GetAlertData();
                                                this.overlay = false;
                                            }
                                        })
                                        .catch(() => {
                                            this.overlay = false;
                                        })
                                    this.GetAlertData();
                                })
                                .catch(() => {
                                    this.overlay = false;
                                    this.$router.push({ path: "/" });
                                })
                        }
                    })
            }
        }
        else
            this.GetAlertData();
    },
    mounted() {
        this.overlay = true;
        axios.post(this.$store.state.URL_GET_AVAILABLE_CLIENT)
            .then(res => {
                res.data.forEach(el => {
                    var element = { text: el.CompanyName, value: el.id }
                    this.clients.push(element);
                    this.filterClients.push(element);
                })
                this.overlay = false;
            })
            .catch(() => {
                this.overlay = false;
            })
    },
    methods: {
        DeleteAlert(item) {
            this.itemToDelete = item;
            this.dialogDeleteConfirm = true;
        },
        confirmDelete() {
            if (this.itemToDelete) {
                this.isDeleting = true;
                this.dialogDeleteConfirm = false;
                
                axios.post(this.$store.state.URL_DELETE_ALERT_MANAGEMENT, {
                    id: this.itemToDelete.Id
                })
                    .then(res => {
                        if (res.data == "ok") {
                            this.GetAlertData();
                            this.id = 0;
                            this.id_sensore = "";
                            this.alertName = "";
                            this.email = "";
                            this.sms = "";
                            this.active = true;
                            this.display_name = "";
                            this.itemToDelete = null;
                        }
                        else {
                            console.log(res.data);
                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
                    .finally(() => {
                        this.isDeleting = false;
                    });
            }
        },
        CreateNew() {
            this.showClient = true;
            this.id = null;
            this.id_sensore = "";
            this.alertName = "";
            this.email = "";
            this.sms = "";
            this.active = true;
            this.display_name = "";
            this.emailCustomMessage = "";
            this.client = "";
            this.buildings.length = 0;
            this.buildings = [];
            this.building = "";
            this.floors.length = 0;
            this.floors = [];
            this.floor = "";
            this.areas.length = 0;
            this.areas = [];
            this.area = "";
            this.sensors.length = 0;
            this.sensors = [];
            this.sensor = "";
            this.alertValue = 0;
            
            // Reset della validazione del form
            this.$nextTick(() => {
                if (this.$refs.alertForm) {
                    this.$refs.alertForm.reset();
                    this.$refs.alertForm.resetValidation();
                }
            });
            
            this.dialogAlert = true;
        },
        GetAlertData() {
            this.overlay = true;
            axios.post(this.$store.state.URLGETALERTSMANAGEMENT,
                {
                    "company": this.$store.state.company,
                    "clientId": this.filterClient,
                    "buildingId": this.filterBuilding,
                    "floorId": this.filterFloor,
                    "areaId": this.filterArea,
                    "sensorId": this.filterSensor
                })
                .then(res => {
                    console.log(res.data);
                    this.list = res.data;
                    this.overlay = false;
                })
                .catch(err => {
                    console.error('Error fetching alerts:', err);
                    this.overlay = false;
                })
        },
        ClearFilter() {
            this.filterClient = '';
            this.filterBuildings.length = 0;
            this.filterBuilding = '';
            this.filterFloor = '';
            this.filterFloors.length = 0;
            this.filterArea = '';
            this.filterAreas.length = 0;
            this.filterSensors.length = 0;
            this.filterSensor = '';
            this.filterBuildings = [];
            this.filterFloors = [];
            this.filterAreas = [];
            this.filterSensors = [];
            this.GetAlertData();
        },
        ApplyFilter() {
            this.GetAlertData();
        },
        SaveData() {
            axios.post(this.$store.state.URL_SAVE_NEW_ALERT_CONFIGURATION, {
                id: this.id,
                title: this.alertName,
                sensors: Array.isArray(this.sensor) ? this.sensor.map(sensor => sensor.id) : this.sensor.id,
                emails: this.email,
                customMessage: this.emailCustomMessage,
                alertValue: this.alertValue

            })
                .then(res => {
                    if (res.data == "ok") {
                        this.dialogAlert = false;
                        this.GetAlertData();
                        this.id = null;
                        this.id_sensore = "";
                        this.alertName = "";
                        this.email = "";
                        this.sms = "";
                        this.active = true;
                        this.display_name = "";
                    }
                })
                .catch(() => {
                    console.log("c'è qualcosa che non va")
                })
        },
        OpenDialog(item) {
            console.log(item);
            this.id = item.Id;
            this.alertName = item.Title;
            this.email = item.EmailAddress;
            var el = {
                text: item.DisplayName,
                value: item,

            }
            this.filteredSensors = [];
            this.filteredSensors.length = 0;
            this.sensor = {};
            this.filteredSensors.push(el);
            this.sensor = item;
            console.log(this.sensor)
            this.showClient = false;
            this.showBuilding = false;
            this.showFloor = false;
            this.showArea = false;
            this.id_sensore = item.IdSensore;
            this.display_name = item.DisplayName;
            this.alertValue = item.AlertValue;
            this.dialogAlert = true;

        }
    },
    watch: {
        // Watch per i filtri della ricerca
        filterClient(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildings = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = { text: "...", value: "" };
                this.filterBuildings.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.filterBuildings.push(element);
                        });
                    })
            }
            else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterBuildings.length = 0;
                this.filterBuilding = '';
                this.filterBuildings = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        },
        filterBuilding(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = {text: "..." , value: ""};
                this.filterFloors.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.filterFloors.push(element);
                        });
                    })
            } else {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterFloors.length = 0;
                this.filterFloor = '';
                this.filterFloors = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        },
        filterFloor(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                var el = {text: "..." , value: ""};
                this.filterAreas.push(el);
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.filterAreas.push(element);
                        });
                    })
            }
            else{
                this.filterAreas.length = 0;
                this.filterArea = '';
                this.filterAreas = [];
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        },
        filterArea(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.filterClient,
                    buildingId: this.filterBuilding,
                    floorId: this.filterFloor,
                    areaId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DispenserUnique, value: el.id }
                            this.filterSensors.push(element);
                        });
                    })
            }
            else{
                this.filterSensors.length = 0;
                this.filterSensor = '';
                this.filterSensors = [];
            }
        },
        // Watch per i campi del dialog di creazione/modifica
        client(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = false;
                this.showArea = false;
                this.floors.length = 0;
                this.areas.length = 0;
                this.areas = [];
                this.floors = [];
                this.showBuilding = true;
                this.buildings.length = 0;
                this.buildings = [];
                this.building = '';
                this.sensor = '';
                this.sensors = [];
                this.sensors.length = 0;
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_AVAILABLE_BUILDINGS, {
                    companyId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.BuildingName, value: el.id }
                            this.buildings.push(element);

                        });
                        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                            companyId: value

                        })
                            .then(res => {
                                res.data.forEach(el => {
                                    var element = { text: el.DisplayName, value: el }
                                    this.filteredSensors.push(element);
                                    this.sensors.push(element);
                                });

                            })
                    })
            }
            else {
                this.showBuilding = false;
                this.buildings.length = 0;
                this.building = '';
                this.floors.length = 0;
                this.areas.length = 0;
                this.areas = [];
                this.floors = [];
                this.buildings = [];
            }
        },
        building(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showFloor = true;
                this.floors.length = 0;
                this.floor = '';
                this.areas.length = 0;
                this.areas = [];
                this.area = '';
                this.floors = [];
                this.sensors = [];
                this.sensors.length = 0;
                this.sensor = "";
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_AVAILABLE_FLOORS, {
                    buildingId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.FloorName, value: el.id }
                            this.floors.push(element);
                        });
                        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                            companyId: this.client,
                            buildingId: value,

                        })
                            .then(res => {
                                res.data.forEach(el => {
                                    var element = { text: el.DisplayName, value: el }
                                    this.filteredSensors.push(element);
                                    this.sensors.push(element);
                                });

                            })
                    })
            }
            else {
                this.showFloor = false;
                this.floors.length = 0;
                this.floor = '';
                this.area = '';
                this.areas = [];
                this.floors = [];
            }
        },
        filterbuilding(value) {
            if (value == "ALL") {
                this.items = this.items_all;
            }
            else {
                this.items = this.items_all.filter(p => p.BuildingName == value);
            }
        },
        floor(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.showArea = true;
                this.areas.length = 0;
                this.area = '';
                this.areas = [];
                this.sensors = [];
                this.sensors.length = 0;
                this.sensor = "";
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_AVAILABLE_AREAS, {
                    floorId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.AreaName, value: el.id }
                            this.areas.push(element);

                        });
                        axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                            companyId: this.client,
                            buildingId: this.building,
                            floorId: value,

                        })
                            .then(res => {
                                res.data.forEach(el => {
                                    var element = { text: el.DisplayName, value: el }
                                    this.filteredSensors.push(element);
                                    this.sensors.push(element);
                                });

                            })
                    })
            }
            else {
                this.showArea = false;
                this.areas.length = 0;
                this.areas = [];
                this.area = '';
            }

        },
        sensore(value) {

            this.id_sensore = value.DispenserUnique;
            this.display_name = value.DisplayName;
            if (this.id_sensore == undefined) {
                this.id_sensore = value.value.DispenserUnique;
                this.display_name = value.value.DisplayName;
            }
        },
        area(value) {
            if (value != undefined &&
                value != null &&
                value != "" &&
                value != 0
            ) {
                this.sensors.length = 0;
                this.sensor = '';
                this.sensors = [];
                this.showSensor = true;
                this.filteredSensors = '';
                this.filteredSensors = [];
                this.filteredSensors.length = 0;
                axios.post(this.$store.state.URL_GET_SENSORS_COMPANY_BUILDING_FLOOR_AREA, {
                    companyId: this.client,
                    buildingId: this.building,
                    floorId: this.floor,
                    areaId: value
                })
                    .then(res => {
                        res.data.forEach(el => {
                            var element = { text: el.DisplayName, value: el }
                            this.filteredSensors.push(element);
                            this.sensors.push(element);
                        });

                    })
            }
        },
        sensor(value) {
            var type = "";
            if (value.length == 0) {
                this.filteredSensors = this.sensors;
            }

            if (value.length == 1) {
                type = value[0].DispenserType;
                switch (type) {
                    case "Dispenser":
                        this.emailCustomMessage = this.dispenserMessage;
                        break;
                    case "Air":
                        this.emailCustomMessage = this.airMessage;
                        break;
                    case "Washroom":
                        this.emailCustomMessage = this.doorMessage;
                        break;
                    case "Cestino":
                        this.emailCustomMessage = this.smartBinMessage;
                        break;
                    case "Button":
                        this.emailCustomMessage = this.smartButtonMessage;
                        break;
                }
                console.log(type)
                console.log(this.emailCustomMessage)
                this.filteredSensors = this.sensors.filter(
                    (sensor) => sensor.value.DispenserType === type
                );
            }
        }
    }
}
</script>
<style scoped>
/*.v-card__subtitle, .v-card__text{
        color: #213A8F !important;
     }*/
.theme--light.v-icon {
    color: #213A8F;
}

.v-list-item__title,
.v-list-item__subtitle {
    color: #234a98 !important;
}

.v-icon.v-icon :not(.v-icon.v-icon[data-v-43d5ffb9]) {
    color: #234a98 !important;
}
</style>
